import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import "./List1.css";
import Chip from "@mui/material/Chip";
import filterIcon from "../../Assets/Icons/Vector.png";
import Stack from "@mui/material/Stack";
import SortIcon from "@mui/icons-material/Sort";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import toast, { Toaster } from "react-hot-toast";
import logo from "../../image/ayekart logo.png";
import { Box } from "@mui/system";
import { ListItemIcon, Popover } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Logout from "@mui/icons-material/Logout";
import { removeToken } from "../../redux/tokenSlice";
import authService from "../../services/auth.service";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { NavBar } from "../Navbar/NavBar";
import moment from "moment";
import Loader from "../Loader";
import Sidebar from "../Sidebar";

export const List2 = () => {
  const history = useNavigate();
  const handleDelete = (chipToDelete) => () => {};
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const loc = useLocation();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [loading, setLoading] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    authService.logout();
    dispatch(removeToken);
    history("/login");
  };
  // ----------------------------API calls----------------------
  const [finalOrders, setFinalOrders] = useState([]);
  const getOrdersInBatch = () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    let data = fetch(
      `/workflow/api/bulk/batches/orders/${loc?.state}?start=0&length=1000`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === true) {
          setFinalOrders(res?.orders);
          setLoading(false);
        }
      });
  };
  useEffect(() => {
    getOrdersInBatch();
  }, []);

  //----------------------------------------
  return (
    <div className="flex">
      <div className="mt-3 ml-8 builk-main ">
        <Loader loading={loading} />
        <div class="order-list-container  mt-5 pt-3">
          <div className="row  pt-2  mx-0 ">
            <div className="col-4 text-start pl-0 fs-5">
              <KeyboardDoubleArrowLeftIcon
                role="button"
                className="text-secondary mr-2"
                onClick={() =>
                  history(`/pre-order-list/Batch/${loc?.state}`, {
                    state: loc?.state,
                  })
                }
              />
              Final Orders/ Batch-ID-{loc?.state}
            </div>
          </div>
          {/* <div className="row  pt-2 pb-2 mx-0 filter-row mt-1">
          <div className="col-2 text-start">
            <span>
              <Chip
                className="ps-3 pe-3 fs-5"
                icon={filterIcon}
                label={"filter"}
                onDelete={() => handleDelete("data")}
                deleteIcon={<SortIcon sx={{ ml: 2 }} />}
              />
            </span>
          </div>

          <div className="col-10 text-start">
            <Chip
              className="me-3 ps-3 pe-3"
              label="Approvals"
              onDelete={handleDelete}
            />
            <Chip
              className="me-3 ps-3 pe-3"
              label="Date"
              onDelete={handleDelete}
            />
            <Chip
              className="me-3 ps-3 pe-3"
              label="Morning Batch"
              onDelete={handleDelete}
            />
          </div>
        </div> */}

          <div className="list-table mt-2">
            <table class="table">
              <thead class="List1-table-header">
                <tr>
                  <th class="header" scope="col">
                    Date
                  </th>
                  <th class="header" scope="col">
                    Order ID
                  </th>
                  <th class="header" scope="col">
                    Buyer
                  </th>
                  {/* <th class="header" scope="col">
                  Seller
                </th> */}
                  <th class="header" scope="col">
                    Supplier
                  </th>
                  <th class="header" scope="col">
                    Amount
                  </th>
                  <th class="header" scope="col">
                    Total CP
                  </th>
                  <th class="header" scope="col">
                    Status
                  </th>
                  <th class="header" scope="col">
                    Payment Method
                  </th>
                  {/* <th class="header" scope="col">
                  <VisibilityIcon />
                </th> */}
                </tr>
              </thead>
              <tbody>
                {finalOrders &&
                  finalOrders?.map((item, index) => (
                    <tr key={index} className="list-table-row">
                      <td>{moment(item?.updated_at).format("DD/MM/yyyy")}</td>
                      <td>{item?.order_id}</td>
                      <td>{item?.buyer_name}</td>
                      {/* <td>{"--NA--"}</td> */}
                      <td>{item?.supplier_name}</td>
                      <td>₹ {Number(item?.total_sp).toFixed(2)} </td>
                      <td className=" ">
                        ₹ {Number(item?.total_cp).toFixed(2)}
                      </td>
                      <td
                        className={
                          item?.order_status === "Pending"
                            ? "text-center text-warning"
                            : "text-center text-success"
                        }
                      >
                        {" "}
                        <small>
                          {item?.order_status ? item?.order_status : "--NA--"}
                        </small>
                        <br />
                      </td>
                      <td className="text-center">
                        {item?.payment_method ? item?.payment_method : "--NA--"}
                      </td>

                      {/* <td className="text-center">
                      <KeyboardArrowRightIcon
                        onClick={() => history("/Batch-ID-12098765")}
                        role="button"
                        className="rounded-circle text-primary"
                      />
                    </td> */}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <Toaster />
      </div>
    </div>
  );
};
